import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { KeepExploringCarousel } from "@faire/retailer/components/KeepExploringCarousel";
import { CarouselContainer, Wrapper } from "./common";
export var CategoriesCarousel = /*#__PURE__*/ React.forwardRef(function(props, ref) {
    return /*#__PURE__*/ _jsx(Wrapper, {
        ref: ref,
        children: /*#__PURE__*/ _jsx(CarouselContainer, {
            children: /*#__PURE__*/ _jsx(KeepExploringCarousel, {
                dataTestId: "logged-out-brand-keep-exploring",
                clickTrackPath: "logged-out-brand/categories-carousel",
                highlightCategoryPath: props.topCategoryPath
            })
        })
    });
});
